import styled from "styled-components";
import theme from "../../../Styles/theme";


import {Container} from "../Sections/styles";


export {Container};

export const Section = styled.section`
width:100%;
display: flex;
align-items: center;
justify-content:space-between;
margin-top:4px ;
`;

interface ContainerInputProps{
    w: number;
}
export const ContainerInput = styled.div<ContainerInputProps>`
width:${({ w }) => (w ? `${w}%` : '100%')};

`;




export const Label = styled.label`
width:100%;
color: ${theme.colors.dark};
font-size: 12px;
font-weight:bold ;
padding: 1vh 1vw;
`;



export const Input = styled.div`

width:100%;
border:solid 1px ${theme.colors.dark};
color: ${theme.colors.dark};
padding: 0.5vh 1vw;
    font-size: 11px;

`;


export const HelperItens = styled.div`
    display:flex;
    width:100%;
    flex-direction: column;
    justify-content:space-between;
   

`;

export const SubSection = styled.section`
width:100%;
display:flex;
align-items:center;
justify-content:space-around;

margin-left: 12px;


`;